export default "__VITE_ASSET__BsTwCUlR__"